
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iy8ZX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f035fef88c8fe9e2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $f035fef88c8fe9e2$export$2e2bcd8739ae039 = {
    'confluence-analytics-chart.default-loading-text': "Actualizando datos de an\xe1lisis...",
    'confluence-analytics-chart.tooltip.no-views-data': 'No hay datos',
    'confluence-analytics-chart.tooltip.views-overall': "{count, plural, one {1\xa0visualizaci\xf3n} other {{count}\xa0visualizaciones}}",
    'confluence-analytics-chart.tooltip.views-today-so-far': "{count, plural, one {1\xa0visualizaci\xf3n hasta ahora} other {{count}\xa0visualizaciones hasta ahora}}",
    'confuence-analytics-chart.accessible-table.caption': "Visualizaciones de p\xe1gina",
    'confuence-analytics-chart.accessible-table.header.date': 'Fecha',
    'confuence-analytics-chart.accessible-table.header.view-count': 'Visualizaciones',
    'confuence-analytics-chart.accessible-table.no-view-count-data': 'Sin visualizaciones'
};

});


//# sourceMappingURL=es.cd051b59.js.map
